import type { FranchiseItemField } from 'interfaces/content/Ranking';
import { Microsites } from 'constants/constants';
import Heading from 'styles/typography/Heading';
import { Table, Wrapper, Footnote } from './SocialHandlesTableStyle';
import Row from './Row';

interface DataTableProps {
  title: string;
  footer?: string;
  footnote?: string;
  values: FranchiseItemField[];
  platformCD: string;
  dataCy?: string;
}

const DataTable = ({ title, footer, footnote, values, platformCD, dataCy }: DataTableProps) => (
  <Wrapper>
    <Heading
      as='h2'
      $fontFamily='graphikCond'
      $size={{ default: 'level3' }}
    >
      {title}
    </Heading>
    <Table>
      <tbody>
        {values.map((item) => (
          <Row
            key={item.title}
            value={item.value}
            title={item.title}
            dataCy={dataCy}
          />
        ))}
      </tbody>
      {footer && (
        <tfoot>
          <td aria-label='footer' />
          <td>{footer}</td>
        </tfoot>
      )}
    </Table>
    {Microsites.Well === platformCD && <Footnote data-cy='well-ranking-list-item-table-footer'> {footnote} </Footnote>}
  </Wrapper>
);

export default DataTable;
